import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'ls-title',
  template: '<h2 class="type-title" ><ng-content></ng-content></h2>',
})
export class TitleComponent {
  @HostBinding('class.d-block') block = true;
}
